import React from "react";

import Masthead, { MastheadTitle } from "@amzn/meridian/masthead";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import cogTokens from "@amzn/meridian-tokens/base/icon/cog";
import userTokens from "@amzn/meridian-tokens/base/icon/user";
import { useAppSelector } from "../../app/store/hooks";
import PropertyTaxLogo from "./Property_tax_logo.svg";
import { VerticalLine } from "../vertical-line/VerticalLine";
import { useNavigate } from "react-router-dom";
import styles from "./style.module.scss";

export const HeaderComponent: React.FC = () => {
    const { firstName } = useAppSelector(state => state.auth.user);
    const navigate = useNavigate();

    return (
        <div className={styles.header}>
            <Masthead>
                <MastheadTitle href="/">
                    <img src={PropertyTaxLogo} alt="Logo" />
                </MastheadTitle>
                <Button
                    onClick={() => navigate("settings", { replace: true })}
                    type="icon"
                    size="small"
                >
                    <Icon tokens={cogTokens} />
                </Button>
                <VerticalLine height={30} />
                <Button type="icon" size="small" onClick={() => {}}>
                    <Icon tokens={userTokens} color="primary"></Icon>
                    {firstName}
                </Button>
            </Masthead>
        </div>
    );
};
